export const VOLUME_TYPE = {
  DATA_DRIVE: 1,
  SNAPSHOT: 2,
}
